import { ChevronRight } from '@carbon/icons-react';
import { useParams } from 'react-router';

import { Button } from 'DesignSystem/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'DesignSystem/ui/dialog';
import track from 'features/Analytics/track';
import { CardConflictDifferenceType } from 'pages/preference-cards/types';

import { CasesTable } from './cases-table';

type CasesDialogProps = {
  itemId: string;
  caseCount: number;
  differenceType?: CardConflictDifferenceType | undefined;
  isPack?: boolean;
  canFetchItemDetails?: boolean;
};

export function CasesDialog({
  itemId,
  caseCount,
  differenceType,
  isPack = false,
  canFetchItemDetails,
}: CasesDialogProps) {
  const { cardId } = useParams<'cardId'>();

  function handleClick() {
    track.pcm.viewCases();
  }
  if (!cardId || !caseCount) return null;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          onClick={handleClick}
          variant="ghost"
          size="sm"
          className="type-body-xs h-full w-full border p-2 font-medium"
        >
          <div className="flex w-full items-center justify-between gap-2 self-stretch">
            <div className="text-left">
              <div className="type-body-xs font-medium leading-4 text-zinc-800">{isPack ? 'Pack Usage' : 'Cases'}</div>
              <div className="type-body-2xs leading-4 text-gray-400">Last 12 months</div>
            </div>
            <div className="flex items-center gap-2">
              {caseCount.toLocaleString()} Cases
              <ChevronRight />
            </div>
          </div>
        </Button>
      </DialogTrigger>

      <DialogContent className="flex w-[1040px] max-w-[80%] bg-white">
        <div className="flex h-full w-full flex-col gap-4">
          <DialogHeader>
            <DialogTitle className="type-body-2xl font-medium">{`${caseCount.toLocaleString()} Cases Associated With This Recommendation`}</DialogTitle>
            <DialogDescription className="type-body font-normal leading-[19px] text-zinc-500">
              Item recommendations are influenced by item usage in single-panel cases completed with this preference
              card by approved physicians at approved sites and approved OR locations within the last 12 months.
            </DialogDescription>
          </DialogHeader>

          <CasesTable
            cardId={cardId}
            itemId={itemId}
            differenceType={differenceType}
            canFetchItemDetails={canFetchItemDetails}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
